var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.3333C12.5303 10.3333 11.7321 10.2097 10.9668 9.96681C10.7334 9.90006 10.4668 9.93328 10.3002 10.1335L8.83331 11.6C6.93325 10.6335 5.40006 9.09997 4.43325 7.19987L5.90009 5.73341C6.06672 5.56675 6.13328 5.30016 6.06672 5.06675C5.79994 4.30016 5.66666 3.5 5.66666 2.66666C5.66666 2.30013 5.36669 2 5 2H2.66666C2.29997 2 2 2.30013 2 2.66666C2 8.93325 7.06675 14 13.3333 14C13.6999 14 14 13.6999 14 13.3333V11C14 10.6335 13.6999 10.3333 13.3333 10.3333Z",
    fill: "#464E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.f10d61f53585efb10e9c16e599494fcd.svg";
export { ForwardRef as ReactComponent };